import { InsuranceCoverageMonitorSettingHelper } from "@wingspanhq/benefits/dist/src/lib/helpers/insuranceCoverageMonitorSettingHelper";
import type {
  insuranceCoverageApiSpec,
  insuranceMonitorApiSpec
} from "@wingspanhq/wingspan-api-types";

type AcceptedInsuranceCoverage =
  insuranceMonitorApiSpec.AcceptedInsuranceCoverage;
type InsuranceCoverage = insuranceCoverageApiSpec.InsuranceCoverage;

// An either/or requirement (multiple accepted policy types on the same
// monitor, e.g. Workers' Compensation OR Occupational Accident) is satisfied
// in full as soon as ONE accepted policy type's checks all pass - it is not
// required that every accepted alternative pass.
export const selectorIsFullMatch = (
  coverages: AcceptedInsuranceCoverage[] | undefined,
  item: InsuranceCoverage
): boolean => {
  if (!coverages) {
    return false;
  }

  return coverages.some(coverage => {
    const validationHelper = new InsuranceCoverageMonitorSettingHelper(
      coverage as any
    );
    return validationHelper
      .validateCoverage(item as any)
      .every(result => result.status === "Complete");
  });
};
